var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "size": _vm.currentStep === 0 ? 'lg' : 'xl',
      "centered": "",
      "id": "group-quote-member-add"
    },
    on: {
      "show": _vm.getPlansData
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeGroupQuoteModal.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm.showHeading ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_vm.currentStep === 1 ? _c('i', {
    staticClass: "fa-solid fa-arrow-left mb-4",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _c('h5', {
    staticClass: "text-center flex-grow-1"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.actionType == 'add' ? "Add New Member" : "Update Member Details") + " ")])])]) : _vm._e(), _c('div', {
    attrs: {
      "id": "quote-member-new"
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_vm.currentStep === 0 ? _c('group-member-details', {
    attrs: {
      "groupCensusId": _vm.groupCensusId,
      "currentGroupPlatform": _vm.currentPlatform
    }
  }) : _vm.currentStep === 1 ? _c('plan-selection', {
    attrs: {
      "groupCensusId": _vm.groupCensusId,
      "quote-type": "group",
      "modal-heading": "Add New Member"
    }
  }) : _vm._e()], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }